import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopNews from '../../common/header/HeaderTopNews';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { FiArrowRight } from 'react-icons/fi';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ConsultingMenu from './../../components/consulting/ConsultingMenu';
import ConsultingAbout from './../../components/consulting/ConsultingAbout';
import ConsultingTopics from './../../components/consulting/ConsultingTopics';
import ConsultingCategories from './../../components/consulting/ConsultingCategories';
import ConsultingCallToAction from './../../components/consulting/ConsultingCallToAction';
import ConsultingTestimonial from '../../components/consulting/ConsultingTestimonial';
import ConsultingVideo from '../../components/consulting/ConsultingVideo';
import SpeakerAbout from './../../components/speaking/SpeakerAbout';
import SpeakerDetails from '../../components/speaking/SpeakingDetails';
import SpeakingSpeaker from '../../components/speaking/SpeakingSpeaker';
import MainTestimonial from '../../elements/testimonial/MainTestimonial';
import TrainingCategories from '../../components/training/TrainingCategories';
import ConsultationPricing from '../../components/consultation/ConsultationPricing';
import ConsultingPrice from './../../components/consulting/ConsultingPrice';
import ConsultingCoaching from '../../components/consulting/ConsultingCoaching';
import ConsultingOneOne from '../../components/consulting/ConsultingOneOne';
import ConsultingForm from '../../components/consulting/ConsultingForm';
import ConsultingConsultent from '../../components/consulting/ConsultingConsultent';

const Consulting = () => {

    return (
        <>
            <SEO title="Book Consultent" />
            <main className="page-wrapper">
                {/* <HeaderTopNews /> */}
                <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="7" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/training/hero.jpg)` }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title display-one">Book <span style={{
                                        background: 'linear-gradient(95deg, var(--color-primary) 15%, var(--color-tertiary) 45%, var(--color-pink) 75%, var(--color-secondary) 100%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        backgroundSize: '200% 100%',
                                        backgroundPosition: '95%',
                                        display: 'inline-block',
                                    }}>Jahid Hasan</span> — Life, Business & Income Strategist.</h1>
                                    <p className="description">Book a one-on-one or group consultation and get tailored strategies to optimize your business systems, scale income streams, and master personal alignment.
                                    </p>
                                    <div>

                                        <div className="button-group">
                                            <a className="btn-default btn-medium round btn-icon" href="#consultingform">Book Now <i className="icon"><FiArrowRight /></i></a>
                                            {/* <Link className="btn-default btn-medium btn-border round btn-icon" to="#">Contact Us <i className="icon"><FiArrowRight /></i></Link> */}
                                        </div>
                                        <img style={{ height: "100px", marginTop: "10px" }} src={`${process.env.PUBLIC_URL}/images/training/down-arrow.avif`} alt="Corporate Logo" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}


                {/* Start Speaker Info*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    // subtitle = "Consulting Services"
                                    title="Consultant"
                                    description=""
                                />
                            </div>
                        </div>
                        {/* <ConsultingDetails/> */}
                        <ConsultingConsultent />
                    </div>
                </div>
                {/* End Speaker Info  */}

                {/* Start Speaker Menu*/}
                <div className="rwt-callto-action-area">
                    <div className="wrapper">
                        <ConsultingMenu />
                    </div>
                </div>
                {/* End Speaker Menu  */}
                {/* Start Speaker About*/}
                <div className="rwt-advance-tab-area rn-section-gap" id='about'>
                    <div className="container">
                        {/* <ConsultingAbout/> */}
                        <SpeakerAbout />
                    </div>
                </div>
                {/* End Speaker About  */}

                {/* Start Elements Area  */}
                <div className="rwt-video-popup-area rn-section-gap" id='videos'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            // subtitle = "Popup Video"
                                            title = "Videos"
                                            description = ""
                                        /> */}
                                <h4 className='text-left'>Videos</h4>
                            </div>
                        </div>
                        <ConsultingVideo />
                    </div>
                </div>
                {/* End Elements Area  */}

                <div className="rwt-advance-tab-area rn-section-gap" id='topics'>
                    <div className="container">
                        <h4 className='text-left'>Topics</h4>
                        <ConsultingTopics />
                    </div>
                </div>
                {/* End Consulting Topics  */}

                {/* Start Elements Area  Community Pricing*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=" Work One-on-One with Jahid Hasan"
                                    title="High-Level Consulting to Accelerate Your Life, Business & Income"
                                    description="No fluff. No theory. Just personalized, proven strategy tailored to your unique challenges and goals. Whether you need breakthrough clarity, a complete reset, or long-term guidance — choose the consulting level that matches your ambition."
                                />
                            </div>
                        </div>
                        <ConsultingPrice />
                    </div>
                </div>
                {/* End Elements Area  */}
                {/* Start Elements Area  One to One Coaching*/}
                <div className="rwt-advance-tab-area">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <ConsultingCoaching />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Elements Area  */}

                {/* Start  One to One Coaching Pricing */}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40 w-75 mx-auto">
                            <div className="col-lg-12">
                                <ConsultingOneOne />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Elements Area  */}
                {/* Start  One to One Coaching Pricing */}
                <div className="rwt-advance-tab-area rn-section-gap" id='consultingform'>
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <ConsultingForm />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Elements Area  */}

                {/* Start Elements Area Testimonmial */}
                <div className="rwt-elements-area rn-section-gap" id='testimonial'>
                    <div className="container">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Client Feedback"
                                    title="Our Awesome Client."
                                    description="We Provide The Best Training & Consulting Services to Improve Your Life, Business & Income."
                                />
                            </div>
                        </div>
                        <MainTestimonial teamStyle="" />
                    </div>
                </div>
                {/* End Elements Area  */}



                {/* Start Categories Area  */}
                <div className="rwt-brand-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    // subtitle = "Our Awesome Client"
                                    title="Featured Category"
                                    description=""
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 mt--10">
                                <TrainingCategories brandStyle="brand-style-2" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Categories Area  */}

                {/* Start Elements Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <ConsultingCallToAction />
                    </div>
                </div>
                {/* End Elements Area  */}



                <FooterOne />
                <Copyright />

            </main>

        </>
    )
}
export default Consulting

